import store from '@/store'
export default {
  data () {
    return {
      tableHeight: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.comptedTableHeight()
    })
    // 窗口发生变化的时候
    let me = this
    window.onresize = () => {
      return (() => {
        me.comptedTableHeight()
      })()
    }
  },
  methods: {
    // 表头颜色
    theme () {
      let themeColor = store.state.settings.theme
      return themeColor
    },
    // 计算表格高度
    comptedTableHeight () {
      let dHeight = document.body.clientHeight
      let searchHeight = this.$refs.searchCondition.clientHeight
      if (this.masterList.notPading) {
        this.tableHeight = dHeight - searchHeight - 149 + 'px'
      } else {
        this.tableHeight = dHeight - searchHeight - 179 + 'px'
      }
    },
    // 查询
    searchData () {
      // 重置右键筛选条件
      this.masterList.tableQuery.page = 1
      this.masterList.tableQuery.contextmenuWrap = []
      // 重置排序条件
      this.masterList.tableQuery.sort.order = ''
      // this.$refs[this.masterList.tableKey].$children[0].clearSort()
      this.loadTableData()
    },
    // 加载数据
    loadTableData () {
      // 缓存查询条件
      sessionStorage.setItem(
        this.masterList.tableKey + '_' + this.masterList.tableIndex,
        JSON.stringify(this.masterList.tableQuery)
      )
      this.masterList.tableIndex++
      // 请求数据
      this.requestData()
    },
    // 处理数据序号及没有查询到数据
    handleData (data) {
      if (data.length > 0) {
        let pageStart = (this.masterList.tableQuery.page - 1) * this.masterList.tableQuery.limit
        data.forEach((item, index) => {
          item['rowNumber'] = Number(pageStart) + Number(index) + 1
        })
        this.masterList.tableData = data
      } else {
        this.masterList.tableData = []

        this.$message({
          dangerouslyUseHTMLString: true,
          message: `<div class="empty-tip" >未能查找到符合条件的数据</div>`,
          customClass: 'empty'
        })
        this.setMessagePos()
      }
    },
    // 设置无数据里消息提示框的位置
    setMessagePos () {
      let box = document.getElementsByClassName('empty')[0]
      let clientHeight = document.body.clientHeight || document.documentElement.clientHeight
      box.style.top = (clientHeight - 50) / 2 + 'px'
    }
  }
}
